import Vue from 'vue'
const expiryPeriod = 15 * 60 * 1000 //5 minutes
export class StorageCache {
    constructor(prefixKey, suffixKey = '') {
        this.suffixKey = suffixKey
        this.prefixKey = prefixKey
    }
    getKey() {
        if (this.suffixKey) {
            return `${this.prefixKey}-${this.suffixKey}`
        } else {
            return this.prefixKey
        }
    }

    getObject() {
        try {
            const obj = JSON.parse(Vue.prototype.$secureStorage.getItem(this.getKey()))
            return {
                ...obj,
                is_valid: Date.now() - obj.timestamp < expiryPeriod,
            }
        } catch (err) {
            return { value: {}, is_valid: false }
        }
    }

    getArray() {
        try {
            const obj = JSON.parse(Vue.prototype.$secureStorage.getItem(this.getKey()))
            return {
                ...obj,
                is_valid: Date.now() - obj.timestamp < expiryPeriod,
            }
        } catch (err) {
            return { value: [], is_valid: false }
        }
    }

    async set(value) {
        try {
            const obj = { value, timestamp: Date.now() }
            const _key = this.getKey()
            Vue.prototype.$secureStorage.setItem(_key, JSON.stringify(obj))
        } catch (err) {
            console.error('set', err)
            await this.reset()
            this.set(value)
            throw new Error('Cannot Store')
        }
    }

    reset() {
        ///////remove all items
        try {
            ////////////////////////
            const { prefixKey } = this
            Vue.prototype.$secureStorage.removeItem(prefixKey)
            //keys from suffix keys
            const keys = Object.keys(localStorage).filter(
                key => key.indexOf(prefixKey) == 0
            )

            console.log('storage keys:', keys)

            ///remove all items
            for (const key of keys) {
                Vue.prototype.$secureStorage.removeItem(key)
            }
            //////////////////////////
        } catch (err) {
            console.error('reset', err)
        }
    }

    updateSelection({ stateList, selectionCommit, sortCompare }, data, id) {
        let idx = stateList.findIndex(x => x.id === id)
        idx = idx >= 0 ? idx : stateList.length

        if (data) stateList.splice(idx, 1, data)
        else stateList.splice(idx, 1)

        if (typeof sortCompare == 'function') stateList.sort(sortCompare)

        this.set(stateList)
        if (typeof selectionCommit == 'function') selectionCommit(data)
    }
}
